// extracted by mini-css-extract-plugin
export var deleteIcon = "_ti-5";
export var deleteOption = "_ti-3";
export var divider = "_ti-2";
export var downloadIcon = "_ti-4";
export var drawer = "_ti-0";
export var drawerFooter = "_ti-6";
export var drawerOpen = "_ti-1";
export var highlighted = "_ti-7";
export var lighterHighlight = "_ti-8";